import { AxiosResponse } from 'axios';

import client from 'api/client';
import type {
    ActivityEventListParams,
    ActivityEventListResponse,
    ActivityEventTypeListResponse,
} from 'types';

export function getActivityEvents(
    params: ActivityEventListParams = {}
): Promise<AxiosResponse<ActivityEventListResponse>> {
    const { event_type, ...rest } = params;
    const types = Array.isArray(event_type)
        ? event_type.filter(Boolean)
        : event_type
          ? [event_type]
          : [];
    return client.get<ActivityEventListResponse>('/events', {
        params: {
            ...rest,
            ...(types.length ? { event_type: types.join(',') } : {}),
        },
    });
}

export function getActivityEventTypes(): Promise<AxiosResponse<ActivityEventTypeListResponse>> {
    return client.get<ActivityEventTypeListResponse>('/events/types');
}
